import {
    TEST,
    SET_MOBILE_NAV_STATUS,
    GET_USER_DATA_STARTED,
    GET_USER_DATA_SUCCESS,
    GET_USER_DATA_FAILURE,
    GET_WALLETS_STARTED,
    GET_WALLETS_SUCCESS,
    GET_WALLETS_FAILURE,
    SET_CABINET_WALLET_RECEIVE_MODAL_STATUS,
    SET_CABINET_WALLET_SEND_MODAL_STATUS,
    GET_RECEIVE_CURRENCY_STARTED,
    GET_RECEIVE_CURRENCY_SUCCESS,
    GET_RECEIVE_CURRENCY_FAILURE,
    GET_RECEIVE_NETWORK_STARTED,
    GET_RECEIVE_NETWORK_SUCCESS,
    GET_RECEIVE_NETWORK_FAILURE,
    GET_RECEIVE_ASSET_STARTED,
    GET_RECEIVE_ASSET_SUCCESS,
    GET_RECEIVE_ASSET_FAILURE,
    GET_SEND_CURRENCY_STARTED,
    GET_SEND_CURRENCY_SUCCESS,
    GET_SEND_CURRENCY_FAILURE,
    GET_SEND_NETWORK_STARTED,
    GET_SEND_NETWORK_SUCCESS,
    GET_SEND_NETWORK_FAILURE,
    GET_SEND_ASSET_STARTED,
    GET_SEND_ASSET_SUCCESS,
    GET_SEND_ASSET_FAILURE,
    GET_SEND_FEE_STARTED,
    GET_SEND_FEE_SUCCESS,
    GET_SEND_FEE_FAILURE,
    GET_WALLET_HISTORY_STARTED,
    GET_WALLET_HISTORY_SUCCESS,
    GET_WALLET_HISTORY_FAILURE,
    GET_MARKET_CHARTS_STARTED,
    GET_MARKET_CHARTS_SUCCESS,
    GET_MARKET_CHARTS_FAILURE,
    GET_PARTNERS_MAIN_DATA_STARTED,
    GET_PARTNERS_MAIN_DATA_SUCCESS,
    GET_PARTNERS_MAIN_DATA_FAILURE,
    GET_ALL_PARTNERS_STARTED,
    GET_ALL_PARTNERS_SUCCESS,
    GET_ALL_PARTNERS_FAILURE,
    EXCHANGE_POINTS_STARTED,
    EXCHANGE_POINTS_SUCCESS,
    EXCHANGE_POINTS_FAILURE,
    GET_PARTNERS_CARD_STARTED,
    GET_PARTNERS_CARD_SUCCESS,
    GET_PARTNERS_CARD_FAILURE,
    SET_CABINET_PARTNERS_CARD_EDIT_MODAL_STATUS,
    SET_PARTNERS_CARD_SETTINGS_STARTED,
    SET_PARTNERS_CARD_SETTINGS_SUCCESS,
    SET_PARTNERS_CARD_SETTINGS_FAILURE,
    SET_CABINET_WALLET_SUBSCRIBE_MODAL_STATUS,
    GET_SUBSCRIBE_STARTED,
    GET_SUBSCRIBE_SUCCESS,
    GET_SUBSCRIBE_FAILURE,
    SET_SUBSCRIBE_STATUS,
    SET_CABINET_PARTNERS_POINTS_HISTORY_MODAL_STATUS,
    SET_CABINET_PARTNERS_CONVERT_POINTS_HISTORY_MODAL_STATUS,
    SET_CABINET_PROFILE_PERSONAL_INFORMATION_EDIT_MODAL_STATUS,
    SET_PROFILE_PERSONAL_INFORMATION_STARTED,
    SET_PROFILE_PERSONAL_INFORMATION_SUCCESS,
    SET_PROFILE_PERSONAL_INFORMATION_FAILURE,
    GET_PROFILE_MAIN_DATA_STARTED,
    GET_PROFILE_MAIN_DATA_SUCCESS,
    GET_PROFILE_MAIN_DATA_FAILURE,
    SET_CABINET_PROFILE_CHANGE_PASSWORD_MODAL_STATUS,
    PROFILE_CHANGE_PASSWORD_STARTED,
    PROFILE_CHANGE_PASSWORD_SUCCESS,
    PROFILE_CHANGE_PASSWORD_FAILURE,
    SET_CABINET_PROFILE_TWO_FACTOR_MODAL_STATUS,
    GET_PROFILE_OPTION_2FA_STARTED,
    GET_PROFILE_OPTION_2FA_SUCCESS,
    GET_PROFILE_OPTION_2FA_FAILURE,
    SET_PROFILE_OPTION_2FA_STARTED,
    SET_PROFILE_OPTION_2FA_SUCCESS,
    SET_PROFILE_OPTION_2FA_FAILURE,
    SET_GOOGLE_CODE_2FA_STARTED,
    SET_GOOGLE_CODE_2FA_SUCCESS,
    SET_GOOGLE_CODE_2FA_FAILURE,
    SET_2FA_SETTINGS_STARTED,
    SET_2FA_SETTINGS_SUCCESS,
    SET_2FA_SETTINGS_FAILURE,
    SET_CABINET_DEPOSIT_OPEN_MODAL_STATUS,
    GET_DEPOSIT_ALL_STARTED,
    GET_DEPOSIT_ALL_SUCCESS,
    GET_DEPOSIT_ALL_FAILURE,
    GET_DEPOSIT_CURRENCY_STARTED,
    GET_DEPOSIT_CURRENCY_SUCCESS,
    GET_DEPOSIT_CURRENCY_FAILURE,
    GET_DEPOSIT_NETWORK_STARTED,
    GET_DEPOSIT_NETWORK_SUCCESS,
    GET_DEPOSIT_NETWORK_FAILURE,
    GET_DEPOSIT_ASSET_STARTED,
    GET_DEPOSIT_ASSET_SUCCESS,
    GET_DEPOSIT_ASSET_FAILURE,
    SET_CABINET_PROFILE_DISABLE_2FA_MODAL_STATUS,
    DISABLE_2FA_STARTED,
    DISABLE_2FA_SUCCESS,
    DISABLE_2FA_FAILURE,
    GET_DEPOSIT_FEE_STARTED,
    GET_DEPOSIT_FEE_SUCCESS,
    GET_DEPOSIT_FEE_FAILURE,
    OPEN_DEPOSIT_STARTED,
    OPEN_DEPOSIT_SUCCESS,
    OPEN_DEPOSIT_FAILURE,
    GET_TWO_FACTOR_OPTIONS_STARTED,
    GET_TWO_FACTOR_OPTIONS_SUCCESS,
    GET_TWO_FACTOR_OPTIONS_FAILURE,
    SEND_CRYPTO_STARTED,
    SEND_CRYPTO_SUCCESS,
    SEND_CRYPTO_FAILURE,
    UPDATE_USER_AVATAR_STARTED,
    UPDATE_USER_AVATAR_SUCCESS,
    UPDATE_USER_AVATAR_FAILURE,
    GET_PARTNERS_CONVERT_HISTORY_STARTED,
    GET_PARTNERS_CONVERT_HISTORY_SUCCESS,
    GET_PARTNERS_CONVERT_HISTORY_FAILURE,
    HIDE_BALANCE_STARTED,
    HIDE_BALANCE_SUCCESS,
    HIDE_BALANCE_FAILURE,
    REFRESH_WALLET_HISTORY
} from "./types";


const initialState = {
    test: false,
    subscribeStatus: localStorage.getItem('b-subscribe'),
    mobileNavStatus: false,
    userDataStarted: false,
    userData: false,
    userDataErr: false,
    logoutStatusStarted: false,
    walletsStarted: false,
    wallets: false,
    walletsErr: false,
    cabinetWalletReceiveModalStatus: false,
    cabinetWalletSendModalStatus: false,
    receiveCurrencyStarted: false,
    receiveCurrency: false,
    receiveCurrencyErr: false,
    receiveNetworkStarted: false,
    receiveNetwork: false,
    receiveNetworkErr: false,
    receiveAssetStarted: false,
    receiveAsset: false,
    receiveAssetErr: false,
    sendCurrencyStarted: false,
    sendCurrency: false,
    sendCurrencyErr: false,
    sendNetworkStarted: false,
    sendNetwork: false,
    sendNetworkCurrencyId: null,
    sendNetworkErr: false,
    sendAssetStarted: false,
    sendAsset: false,
    sendAssetErr: false,
    sendFeeStarted: false,
    sendFee: false,
    sendFeeErr: false,
    walletHistoryStarted: false,
    walletHistory: false,
    walletHistoryErr: false,
    marketChartsStarted: false,
    marketCharts: false,
    marketChartsErr: false,
    partnersMainDataStarted: false,
    partnersMainData: false,
    partnersMainDataErr: false,
    partnersAllStarted: false,
    partnersAll: false,
    partnersAllErr: false,
    exchangePointsStatusStarted: false,
    exchangePointsStatus: false,
    exchangePointsStatusErr: false,
    partnersCardStarted: false,
    partnersCard: false,
    partnersCardErr: false,
    cabinetPartnersCardEditModalStatus: false,
    partnersCardSettingsStatusStarted: false,
    partnersCardSettingsStatus: false,
    partnersCardSettingsStatusErr: false,
    cabinetWalletSubscribeModalStatus: false,
    getSubscribeStatusStarted: false,
    getSubscribeStatus: false,
    getSubscribeStatusErr: false,
    cabinetPartnersPointsHistoryModalStatus: false,
    cabinetPartnersConvertPointsHistoryModalStatus: false,
    cabinetProfilePersonalInformationEditModalStatus: false,
    profilePersonalInformationEditStatusStarted: false,
    profilePersonalInformationEditStatus: false,
    profilePersonalInformationEditStatusErr: false,
    profileMainDataStarted: false,
    profileMainData: false,
    profileMainDataErr: false,
    cabinetProfileChangePasswordModalStatus: false,
    profileChangePasswordStatusStarted: false,
    profileChangePasswordStatus: false,
    profileChangePasswordStatusErr: false,
    cabinetProfileTwoFactorModalStatus: false,
    profile2faOptionStarted: false,
    profile2faOption: false,
    profile2faOptionErr: false,
    profile2faSelectedOptionStarted: false,
    profile2faSelectedOption: false,
    profile2faSelectedOptionErr: false,
    profile2faGoogleCodeStatusStarted: false,
    profile2faGoogleCodeStatus: false,
    profile2faGoogleCodeStatusErr: false,
    profile2faSettingsStatusStarted: false,
    profile2faSettingsStatus: false,
    profile2faSettingsStatusErr: false,
    cabinetDepositOpenModalStatus: false,
    depositAllStatusStarted: false,
    depositAllStatus: false,
    depositAllStatusErr: false,
    depositCurrencyStarted: false,
    depositCurrency: false,
    depositCurrencyErr: false,
    depositNetworkStarted: false,
    depositNetwork: false,
    depositNetworkCurrencyId: null,
    depositNetworkErr: false,
    depositAssetStarted: false,
    depositAsset: false,
    depositAssetErr: false,
    cabinetProfileDisableTwoFactorModalStatus: false,
    disable2faStarted: false,
    disable2faStatus: false,
    disable2faErr: false,
    depositFeeStarted: false,
    depositFee: false,
    depositFeeErr: false,
    depositOpenStarted: false,
    depositOpenStatus: false,
    depositOpenErr: false,
    twoFactorOptionsStarted: false,
    twoFactorOptions: false,
    twoFactorOptionsErr: false,
    sendCryptoStarted: false,
    sendCryptoStatus: false,
    sendCryptoErr: false,
    updateUserAvatarStarted: false,
    updateUserAvatarStatus: false,
    updateUserAvatarErr: false,
    partnersConvertHistoryStarted: false,
    partnersConvertHistory: false,
    partnersConvertHistoryErr: false,
    hideBalanceStatusStarted: false,
    hideBalanceStatus: false,
    hideBalanceStatusErr: false,
    walletHistoryRefreshKey: 0
};

export function cabinetReducer(state = initialState, action) {
    switch (action.type) {
        case TEST:
            return {
                ...state,
                test: action.payload
            };
        case SET_SUBSCRIBE_STATUS:
            return {
                ...state,
                subscribeStatus: action.payload
            };
        case SET_MOBILE_NAV_STATUS:
            return {
                ...state,
                mobileNavStatus: action.payload
            };
        case GET_USER_DATA_STARTED:
            return {
                ...state,
                userDataStarted: true
            };
        case GET_USER_DATA_SUCCESS:
            return {
                ...state,
                userData: action.payload,
                userDataStarted: false
            };
        case GET_USER_DATA_FAILURE:
            return {
                ...state,
                userDataErr: action.payload,
                userDataStarted: false
            };
        case GET_WALLETS_STARTED:
            return {
                ...state,
                walletsStarted: true
            };
        case GET_WALLETS_SUCCESS:
            return {
                ...state,
                wallets: action.payload,
                walletsStarted: false
            };
        case GET_WALLETS_FAILURE:
            return {
                ...state,
                walletsErr: action.payload,
                walletsStarted: false
            };
        case SET_CABINET_WALLET_RECEIVE_MODAL_STATUS:
            return {
                ...state,
                cabinetWalletReceiveModalStatus: action.payload
            };
        case SET_CABINET_WALLET_SEND_MODAL_STATUS:
            return {
                ...state,
                cabinetWalletSendModalStatus: action.payload
            };
        case GET_RECEIVE_CURRENCY_STARTED:
            return {
                ...state,
                receiveCurrencyStarted: true
            };
        case GET_RECEIVE_CURRENCY_SUCCESS:
            return {
                ...state,
                receiveCurrency: action.payload,
                receiveCurrencyStarted: false
            };
        case GET_RECEIVE_CURRENCY_FAILURE:
            return {
                ...state,
                receiveCurrencyErr: action.payload,
                receiveCurrencyStarted: false
            };
        case GET_RECEIVE_NETWORK_STARTED:
            return {
                ...state,
                receiveNetworkStarted: true
            };
        case GET_RECEIVE_NETWORK_SUCCESS:
            return {
                ...state,
                receiveNetwork: action.payload,
                receiveNetworkStarted: false
            };
        case GET_RECEIVE_NETWORK_FAILURE:
            return {
                ...state,
                receiveNetworkErr: action.payload,
                receiveNetworkStarted: false
            };
        case GET_RECEIVE_ASSET_STARTED:
            return {
                ...state,
                receiveAssetStarted: true
            };
        case GET_RECEIVE_ASSET_SUCCESS:
            return {
                ...state,
                receiveAsset: action.payload,
                receiveAssetStarted: false
            };
        case GET_RECEIVE_ASSET_FAILURE:
            return {
                ...state,
                receiveAssetErr: action.payload,
                receiveAssetStarted: false
            };
        case GET_SEND_CURRENCY_STARTED:
            return {
                ...state,
                sendCurrencyStarted: true
            };
        case GET_SEND_CURRENCY_SUCCESS:
            return {
                ...state,
                sendCurrency: action.payload,
                sendCurrencyStarted: false
            };
        case GET_SEND_CURRENCY_FAILURE:
            return {
                ...state,
                sendCurrencyErr: action.payload,
                sendCurrencyStarted: false
            };
        case GET_SEND_NETWORK_STARTED:
            return {
                ...state,
                sendNetworkStarted: true,
                sendNetwork: false,
                sendNetworkCurrencyId: action.payload,
                sendNetworkErr: false,
                sendAsset: false,
                sendAssetErr: false,
                sendFee: false,
                sendFeeErr: false
            };
        case GET_SEND_NETWORK_SUCCESS:
            return {
                ...state,
                sendNetwork: action.payload,
                sendNetworkStarted: false,
                sendNetworkErr: false
            };
        case GET_SEND_NETWORK_FAILURE:
            return {
                ...state,
                sendNetwork: false,
                sendNetworkErr: action.payload,
                sendNetworkStarted: false
            };
        case GET_SEND_ASSET_STARTED:
            return {
                ...state,
                sendAssetStarted: true,
                sendAsset: false,
                sendAssetErr: false
            };
        case GET_SEND_ASSET_SUCCESS:
            return {
                ...state,
                sendAsset: action.payload,
                sendAssetStarted: false,
                sendAssetErr: false
            };
        case GET_SEND_ASSET_FAILURE:
            return {
                ...state,
                sendAsset: false,
                sendAssetErr: action.payload,
                sendAssetStarted: false
            };
        case GET_SEND_FEE_STARTED:
            return {
                ...state,
                sendFeeStarted: true,
                sendFee: false,
                sendFeeErr: false
            };
        case GET_SEND_FEE_SUCCESS:
            return {
                ...state,
                sendFee: action.payload,
                sendFeeStarted: false,
                sendFeeErr: false
            };
        case GET_SEND_FEE_FAILURE:
            return {
                ...state,
                sendFee: false,
                sendFeeErr: action.payload,
                sendFeeStarted: false
            };
        case GET_WALLET_HISTORY_STARTED:
            return {
                ...state,
                walletHistoryStarted: true
            };
        case GET_WALLET_HISTORY_SUCCESS:
            return {
                ...state,
                walletHistory: action.payload,
                walletHistoryStarted: false
            };
        case GET_WALLET_HISTORY_FAILURE:
            return {
                ...state,
                walletHistoryErr: action.payload,
                walletHistoryStarted: false
            };
        case GET_MARKET_CHARTS_STARTED:
            return {
                ...state,
                marketChartsStarted: true
            };
        case GET_MARKET_CHARTS_SUCCESS:
            return {
                ...state,
                marketCharts: action.payload,
                marketChartsStarted: false
            };
        case GET_MARKET_CHARTS_FAILURE:
            return {
                ...state,
                marketChartsErr: action.payload,
                marketChartsStarted: false
            };
        case GET_PARTNERS_MAIN_DATA_STARTED:
            return {
                ...state,
                partnersMainDataStarted: true
            };
        case GET_PARTNERS_MAIN_DATA_SUCCESS:
            return {
                ...state,
                partnersMainData: action.payload,
                partnersMainDataStarted: false
            };
        case GET_PARTNERS_MAIN_DATA_FAILURE:
            return {
                ...state,
                partnersMainDataErr: action.payload,
                partnersMainDataStarted: false
            };
        case GET_ALL_PARTNERS_STARTED:
            return {
                ...state,
                partnersAllStarted: true
            };
        case GET_ALL_PARTNERS_SUCCESS:
            return {
                ...state,
                partnersAll: action.payload,
                partnersAllStarted: false
            };
        case GET_ALL_PARTNERS_FAILURE:
            return {
                ...state,
                partnersAllErr: action.payload,
                partnersAllStarted: false
            };
        case EXCHANGE_POINTS_STARTED:
            return {
                ...state,
                exchangePointsStatusStarted: true
            };
        case EXCHANGE_POINTS_SUCCESS:
            return {
                ...state,
                exchangePointsStatus: action.payload,
                exchangePointsStatusStarted: false
            };
        case EXCHANGE_POINTS_FAILURE:
            return {
                ...state,
                exchangePointsStatusErr: action.payload,
                exchangePointsStatusStarted: false
            };
        case GET_PARTNERS_CARD_STARTED:
            return {
                ...state,
                partnersCardStarted: true
            };
        case GET_PARTNERS_CARD_SUCCESS:
            return {
                ...state,
                partnersCard: action.payload,
                partnersCardStarted: false
            };
        case GET_PARTNERS_CARD_FAILURE:
            return {
                ...state,
                partnersCardErr: action.payload,
                partnersCardStarted: false
            };
        case SET_CABINET_PARTNERS_CARD_EDIT_MODAL_STATUS:
            return {
                ...state,
                cabinetPartnersCardEditModalStatus: action.payload
            };
        case SET_PARTNERS_CARD_SETTINGS_STARTED:
            return {
                ...state,
                partnersCardSettingsStatusStarted: true
            };
        case SET_PARTNERS_CARD_SETTINGS_SUCCESS:
            return {
                ...state,
                partnersCardSettingsStatus: action.payload,
                partnersCardSettingsStatusStarted: false
            };
        case SET_PARTNERS_CARD_SETTINGS_FAILURE:
            return {
                ...state,
                partnersCardSettingsStatusErr: action.payload,
                partnersCardSettingsStatusStarted: false
            };
        case SET_CABINET_WALLET_SUBSCRIBE_MODAL_STATUS:
            return {
                ...state,
                cabinetWalletSubscribeModalStatus: action.payload
            };
        case GET_SUBSCRIBE_STARTED:
            return {
                ...state,
                getSubscribeStatusStarted: true
            };
        case GET_SUBSCRIBE_SUCCESS:
            return {
                ...state,
                getSubscribeStatus: action.payload,
                getSubscribeStatusStarted: false
            };
        case GET_SUBSCRIBE_FAILURE:
            return {
                ...state,
                getSubscribeStatusErr: action.payload,
                getSubscribeStatusStarted: false
            };
        case SET_CABINET_PARTNERS_POINTS_HISTORY_MODAL_STATUS:
            return {
                ...state,
                cabinetPartnersPointsHistoryModalStatus: action.payload
            };
        case SET_CABINET_PARTNERS_CONVERT_POINTS_HISTORY_MODAL_STATUS:
            return {
                ...state,
                cabinetPartnersConvertPointsHistoryModalStatus: action.payload
            };
        case SET_CABINET_PROFILE_PERSONAL_INFORMATION_EDIT_MODAL_STATUS:
            return {
                ...state,
                cabinetProfilePersonalInformationEditModalStatus: action.payload
            };
        case SET_PROFILE_PERSONAL_INFORMATION_STARTED:
            return {
                ...state,
                profilePersonalInformationEditStatusStarted: true
            };
        case SET_PROFILE_PERSONAL_INFORMATION_SUCCESS:
            return {
                ...state,
                profilePersonalInformationEditStatus: action.payload,
                profilePersonalInformationEditStatusStarted: false
            };
        case SET_PROFILE_PERSONAL_INFORMATION_FAILURE:
            return {
                ...state,
                profilePersonalInformationEditStatusErr: action.payload,
                profilePersonalInformationEditStatusStarted: false
            };
        case GET_PROFILE_MAIN_DATA_STARTED:
            return {
                ...state,
                profileMainDataStarted: true
            };
        case GET_PROFILE_MAIN_DATA_SUCCESS:
            return {
                ...state,
                profileMainData: action.payload,
                profileMainDataStarted: false
            };
        case GET_PROFILE_MAIN_DATA_FAILURE:
            return {
                ...state,
                profileMainDataErr: action.payload,
                profileMainDataStarted: false
            };
        case SET_CABINET_PROFILE_CHANGE_PASSWORD_MODAL_STATUS:
            return {
                ...state,
                cabinetProfileChangePasswordModalStatus: action.payload
            };
        case PROFILE_CHANGE_PASSWORD_STARTED:
            return {
                ...state,
                profileChangePasswordStatusStarted: true
            };
        case PROFILE_CHANGE_PASSWORD_SUCCESS:
            return {
                ...state,
                profileChangePasswordStatus: action.payload,
                profileChangePasswordStatusStarted: false
            };
        case PROFILE_CHANGE_PASSWORD_FAILURE:
            return {
                ...state,
                profileChangePasswordStatusErr: action.payload,
                profileChangePasswordStatusStarted: false
            };
        case GET_PROFILE_OPTION_2FA_STARTED:
            return {
                ...state,
                profile2faOptionStarted: true
            };
        case GET_PROFILE_OPTION_2FA_SUCCESS:
            return {
                ...state,
                profile2faOption: action.payload,
                profile2faOptionStarted: false
            };
        case GET_PROFILE_OPTION_2FA_FAILURE:
            return {
                ...state,
                profile2faOptionErr: action.payload,
                profile2faOptionStarted: false
            };
        case SET_CABINET_PROFILE_TWO_FACTOR_MODAL_STATUS:
            return {
                ...state,
                cabinetProfileTwoFactorModalStatus: action.payload
            };
        case SET_PROFILE_OPTION_2FA_STARTED:
            return {
                ...state,
                profile2faSelectedOptionStarted: true
            };
        case SET_PROFILE_OPTION_2FA_SUCCESS:
            return {
                ...state,
                profile2faSelectedOption: action.payload,
                profile2faSelectedOptionStarted: false
            };
        case SET_PROFILE_OPTION_2FA_FAILURE:
            return {
                ...state,
                profile2faSelectedOptionErr: action.payload,
                profile2faSelectedOptionStarted: false
            };
        case SET_GOOGLE_CODE_2FA_STARTED:
            return {
                ...state,
                profile2faGoogleCodeStatusStarted: true,
                profile2faGoogleCodeStatusErr: null,
            };

        case SET_GOOGLE_CODE_2FA_SUCCESS:
            return {
                ...state,
                profile2faGoogleCodeStatus: action.payload,
                profile2faGoogleCodeStatusStarted: false,
                profile2faGoogleCodeStatusErr: null,
            };

        case SET_GOOGLE_CODE_2FA_FAILURE:
            return {
                ...state,
                profile2faGoogleCodeStatusErr: action.payload,
                profile2faGoogleCodeStatusStarted: false,
            };
        case SET_2FA_SETTINGS_STARTED:
            return {
                ...state,
                profile2faSettingsStatusStarted: true,
                profile2faSettingsStatusErr: null,
            };

        case SET_2FA_SETTINGS_SUCCESS:
            return {
                ...state,
                profile2faSettingsStatus: action.payload,
                profile2faSettingsStatusStarted: false,
                profile2faSettingsStatusErr: null,
            };

        case SET_2FA_SETTINGS_FAILURE:
            return {
                ...state,
                profile2faSettingsStatusErr: action.payload,
                profile2faSettingsStatusStarted: false,
            };
        case SET_CABINET_DEPOSIT_OPEN_MODAL_STATUS:
            return {
                ...state,
                cabinetDepositOpenModalStatus: action.payload
            };
        case GET_DEPOSIT_ALL_STARTED:
            return {
                ...state,
                depositAllStatusStarted: true
            };
        case GET_DEPOSIT_ALL_SUCCESS:
            return {
                ...state,
                depositAllStatus: action.payload,
                depositAllStatusStarted: false
            };
        case GET_DEPOSIT_ALL_FAILURE:
            return {
                ...state,
                depositAllStatusErr: action.payload,
                depositAllStatusStarted: false
            };
        case GET_DEPOSIT_CURRENCY_STARTED:
            return {
                ...state,
                depositCurrencyStarted: true,
                depositCurrencyErr: false
            };
        case GET_DEPOSIT_CURRENCY_SUCCESS:
            return {
                ...state,
                depositCurrency: action.payload,
                depositCurrencyStarted: false,
                depositCurrencyErr: false
            };
        case GET_DEPOSIT_CURRENCY_FAILURE:
            return {
                ...state,
                depositCurrencyErr: action.payload,
                depositCurrencyStarted: false
            };
        case GET_DEPOSIT_NETWORK_STARTED:
            return {
                ...state,
                depositNetworkStarted: true,
                depositNetwork: false,
                depositNetworkCurrencyId: action.payload,
                depositNetworkErr: false,
                depositAsset: false,
                depositAssetErr: false
            };
        case GET_DEPOSIT_NETWORK_SUCCESS:
            return {
                ...state,
                depositNetwork: action.payload,
                depositNetworkStarted: false,
                depositNetworkErr: false
            };
        case GET_DEPOSIT_NETWORK_FAILURE:
            return {
                ...state,
                depositNetwork: false,
                depositNetworkErr: action.payload,
                depositNetworkStarted: false
            };
        case GET_DEPOSIT_ASSET_STARTED:
            return {
                ...state,
                depositAssetStarted: true,
                depositAsset: false,
                depositAssetErr: false
            };
        case GET_DEPOSIT_ASSET_SUCCESS:
            return {
                ...state,
                depositAsset: action.payload,
                depositAssetStarted: false,
                depositAssetErr: false
            };
        case GET_DEPOSIT_ASSET_FAILURE:
            return {
                ...state,
                depositAsset: false,
                depositAssetErr: action.payload,
                depositAssetStarted: false
            };
        case SET_CABINET_PROFILE_DISABLE_2FA_MODAL_STATUS:
            return {
                ...state,
                cabinetProfileDisableTwoFactorModalStatus: action.payload
            };
        case DISABLE_2FA_STARTED:
            return {
                ...state,
                disable2faStarted: true,
                disable2faErr: null,
            };

        case DISABLE_2FA_SUCCESS:
            return {
                ...state,
                disable2faStatus: action.payload,
                disable2faStarted: false,
                disable2faErr: null,
            };

        case DISABLE_2FA_FAILURE:
            return {
                ...state,
                disable2faErr: action.payload,
                disable2faStarted: false,
            };
        case GET_DEPOSIT_FEE_STARTED:
            return {
                ...state,
                depositFeeStarted: true,
                depositFee: false,
                depositFeeErr: false,
            };

        case GET_DEPOSIT_FEE_SUCCESS:
            return {
                ...state,
                depositFee: action.payload,
                depositFeeStarted: false,
                depositFeeErr: false,
            };

        case GET_DEPOSIT_FEE_FAILURE:
            return {
                ...state,
                depositFeeErr: action.payload,
                depositFeeStarted: false,
            };
        case OPEN_DEPOSIT_STARTED:
            return {
                ...state,
                depositOpenStarted: true,
                depositOpenErr: false,
            };

        case OPEN_DEPOSIT_SUCCESS:
            return {
                ...state,
                depositOpenStatus: action.payload,
                depositOpenStarted: false,
                depositOpenErr: false,
            };

        case OPEN_DEPOSIT_FAILURE:
            return {
                ...state,
                depositOpenErr: action.payload,
                depositOpenStarted: false,
            };
        case GET_TWO_FACTOR_OPTIONS_STARTED:
            return {
                ...state,
                twoFactorOptionsStarted: true,
                twoFactorOptionsErr: false,
            };

        case GET_TWO_FACTOR_OPTIONS_SUCCESS:
            return {
                ...state,
                twoFactorOptions: action.payload,
                twoFactorOptionsStarted: false,
                twoFactorOptionsErr: false,
            };

        case GET_TWO_FACTOR_OPTIONS_FAILURE:
            return {
                ...state,
                twoFactorOptionsErr: action.payload,
                twoFactorOptionsStarted: false,
            };
        case SEND_CRYPTO_STARTED:
            return {
                ...state,
                sendCryptoStarted: true,
                sendCryptoErr: false,
            };

        case SEND_CRYPTO_SUCCESS:
            return {
                ...state,
                sendCryptoStatus: action.payload,
                sendCryptoStarted: false,
                sendCryptoErr: false,
            };

        case SEND_CRYPTO_FAILURE:
            return {
                ...state,
                sendCryptoErr: action.payload,
                sendCryptoStarted: false,
            };
        case UPDATE_USER_AVATAR_STARTED:
            return {
                ...state,
                updateUserAvatarStarted: true,
                updateUserAvatarErr: false,
            };

        case UPDATE_USER_AVATAR_SUCCESS:
            return {
                ...state,
                updateUserAvatarStatus: action.payload,
                updateUserAvatarStarted: false,
                updateUserAvatarErr: false,
                userData: {
                    ...state.userData,
                    avatar: action.payload?.avatar || state.userData?.avatar,
                    avatar_url: action.payload?.avatar_url || state.userData?.avatar_url,
                    avatarUrl: action.payload?.avatar_url || state.userData?.avatarUrl,
                },
            };

        case UPDATE_USER_AVATAR_FAILURE:
            return {
                ...state,
                updateUserAvatarErr: action.payload,
                updateUserAvatarStarted: false,
            };
        case GET_PARTNERS_CONVERT_HISTORY_STARTED:
            return {
                ...state,
                partnersConvertHistoryStarted: true
            };
        case GET_PARTNERS_CONVERT_HISTORY_SUCCESS:
            return {
                ...state,
                partnersConvertHistory: action.payload,
                partnersConvertHistoryStarted: false
            };
        case GET_PARTNERS_CONVERT_HISTORY_FAILURE:
            return {
                ...state,
                partnersConvertHistoryErr: action.payload,
                partnersConvertHistoryStarted: false
            };
        case HIDE_BALANCE_STARTED:
            return {
                ...state,
                hideBalanceStatusStarted: true
            };
        case HIDE_BALANCE_SUCCESS:
            return {
                ...state,
                hideBalanceStatus: action.payload,
                hideBalanceStatusStarted: false
            };
        case HIDE_BALANCE_FAILURE:
            return {
                ...state,
                hideBalanceStatusErr: action.payload,
                hideBalanceStatusStarted: false
            };
        case REFRESH_WALLET_HISTORY:
            return {
                ...state,
                walletHistoryRefreshKey: state.walletHistoryRefreshKey + 1,
            };
        default:
            return state;
    }
}

